import { Typography } from '@mui/material';
import React from 'react';

interface FormHeadingProps {
    editedId?: number | string;
    entityName: string;
}

/**
 * A little helper to generate Create/Edit form header based on entityId.
 *
 * @constructor
 */
export const FormHeading: React.FunctionComponent<FormHeadingProps> = ({ entityName, editedId }) => (
    <Typography variant='h4'>
        {!editedId ? 'Create' : 'Edit'} {entityName}
        {!editedId ? '' : `: ${editedId}`}
    </Typography>
);
